import React, { useEffect, useRef } from "react";
import {
    BathroomIcon,
    BedIcon,
    FavoriteIcon,
    HeardIcon,
    LeftArrowIcon,
    NoteIcon,
    PossibilityIcon,
    RightArrowIcon,
    RightArrowIconCircle,
    LeftArrowIconCircle,
    SavedIcon,
    ImagesIcon,
  } from "../../constants/icons.jsx";
  import "./OpenHouse.css";
import { addToCalendar, formatOpenHouseDate } from "../../constants/methods.js";


  const OpenHouse = ({
    item,
    OpenHouseData,
    closeWrapper,
    container
  }) => {
    const ulRef = useRef(null);

    useEffect(() => {
      if (ulRef.current) {
        if (OpenHouseData?.length <= 3) {
          ulRef.current.style.display = "flex";
          ulRef.current.style.justifyContent = "center";
        } else {
          ulRef.current.style.justifyContent = "flex-start"; // Default behavior
        }
      }
    }, [ulRef, OpenHouseData]);

    return (
        <div className="open-house-wrapper">
            <div className="open-house-wrapper-close" onClick={()=>{closeWrapper(false)}}>
                <span>X</span>
            </div>
            <ul ref={ulRef}>
                {
                    OpenHouseData.map(openhouse=>{
                        
                        return <li key={openhouse.OpenHouseKeyNumeric}>
                                <span>{!openhouse.hasOwnProperty("f_date")?formatOpenHouseDate(openhouse):openhouse.f_date}</span>
                                <a type="button" role="button" onClick={()=>{addToCalendar(item, openhouse)}}>Add to calendar</a>
                              </li>
                    })
                }
            </ul>
        </div>
    )
  }

  export default OpenHouse;
